// DEPENDENCIES
import React from 'react';
// COMPONENTS
import { Link } from 'react-router-dom';
// ICONS
import { IoClose } from "react-icons/io5";
// CUSTOM COMPONENT
import CustomBlock from './CustomBlock';
import Overlay from './Overlay';

const BottomSheet = (props) => {

    const bottomSheetHeight = {
        full: "full",
        half: "half",
        normal: "normal"
    }

    return (
        <>
            {
                props.open ?
                    <Overlay onClick={props.closeOnMaskPress ? props.onClick : () => { }} /> : <></>
            }
            <CustomBlock className="bottom-sheet-container">
                <CustomBlock
                    className={`bottom-sheet ${props.rounded ? "rounded" : ""} ${props.open ? (props.height ? bottomSheetHeight[props.height] : "normal") : ""} ${props.previewHeight ? "with-preview" : ""} ${props.className ? props.className : ""}`}
                    style={{
                        transform: `translate3d(0, ${props.previewHeight ? props.previewHeight : 100}vh, 0)`
                    }}
                >
                    <Link onClick={props.onClick ? props.onClick : () => { }}>
                        <CustomBlock className="bottom-sheet-header">
                            <p>
                                {props.title}
                            </p>

                            {
                                props.onClick &&
                                <Link
                                    className={`bottom-sheet-icon-container ${props.iconContainerClass ? props.iconContainerClass : ""}`}
                                    onClick={props.onClick ? props.onClick : () => { }}
                                    style={props.iconContainerStyle}
                                >
                                    {
                                        props.icon ? props.icon : <IoClose size={20} />
                                    }
                                </Link>
                            }
                        </CustomBlock>
                    </Link>
                    <CustomBlock className="bottom-sheet-content-container">
                        {props.children}
                    </CustomBlock>
                </CustomBlock>
            </CustomBlock>
        </>
    );
}

export default BottomSheet;